import { Deserializable } from '../protocols/deserializable';
import { Attachment } from './attachment';
import { SpousalWaiverTypeEnum } from '../spousal-waivers/spousal-waiver-type.enum';
import { BaseType } from '../base/base-type';

export class SpousalWaiverAttachment implements Deserializable {
  public id!: string;
  public attachment!: Attachment;
  public waiverType!: BaseType;
  public waiverTypeId!: SpousalWaiverTypeEnum;
  public signedDate!: string;
  public effectiveDate!: string;

  public onDeserialize() {
    if (this.attachment) {
      this.attachment = window.injector.Deserialize.instanceOf(Attachment, this.attachment);
    }
  }
}
